export const ADMIN_MERCHANT_CREATE_REQUEST = "ADMIN_MERCHANT_CREATE_REQUEST";
export const ADMIN_MERCHANT_CREATE_SUCCESS = "ADMIN_MERCHANT_CREATE_SUCCESS";
export const ADMIN_MERCHANT_CREATE_FAIL = "ADMIN_MERCHANT_CREATE_FAIL";
export const ADMIN_MERCHANT_CREATE_RESET = "ADMIN_MERCHANT_CREATE_RESET";

export const ADMIN_MERCHANT_LIST_REQUEST = "ADMIN_MERCHANT_LIST_REQUEST";
export const ADMIN_MERCHANT_LIST_SUCCESS = "ADMIN_MERCHANT_LIST_SUCCESS";
export const ADMIN_MERCHANT_LIST_FAIL = "ADMIN_MERCHANT_LIST_FAIL";
export const ADMIN_MERCHANT_LIST_SEARCH = "ADMIN_MERCHANT_LIST_SEARCH";

export const ADMIN_MERCHANT_VIEW_REQUEST = "ADMIN_MERCHANT_VIEW_REQUEST";
export const ADMIN_MERCHANT_VIEW_SUCCESS = "ADMIN_MERCHANT_VIEW_SUCCESS";
export const ADMIN_MERCHANT_VIEW_FAIL = "ADMIN_MERCHANT_VIEW_FAIL";

export const ADMIN_MERCHANT_UPDATE_REQUEST = "ADMIN_MERCHANT_UPDATE_REQUEST";
export const ADMIN_MERCHANT_UPDATE_SUCCESS = "ADMIN_MERCHANT_UPDATE_SUCCESS";
export const ADMIN_MERCHANT_UPDATE_FAIL = "ADMIN_MERCHANT_UPDATE_FAIL";
export const ADMIN_MERCHANT_UPDATE_RESET = "ADMIN_MERCHANT_UPDATE_RESET";

export const ADMIN_MERCHANT_SEARCH_BRAND_REQUEST = "ADMIN_MERCHANT_SEARCH_BRAND_REQUEST";
export const ADMIN_MERCHANT_SEARCH_BRAND_SUCCESS = "ADMIN_MERCHANT_SEARCH_BRAND_SUCCESS";
export const ADMIN_MERCHANT_SEARCH_BRAND_FAIL = "ADMIN_MERCHANT_SEARCH_BRAND_FAIL";
export const ADMIN_MERCHANT_SEARCH_BRAND_RESET = "ADMIN_MERCHANT_SEARCH_BRAND_RESET";

export const ADMIN_MERCHANT_SEARCH_BRANDS_REQUEST = "ADMIN_MERCHANT_SEARCH_BRANDS_REQUEST";
export const ADMIN_MERCHANT_SEARCH_BRANDS_SUCCESS = "ADMIN_MERCHANT_SEARCH_BRANDS_SUCCESS";
export const ADMIN_MERCHANT_SEARCH_BRANDS_FAIL = "ADMIN_MERCHANT_SEARCH_BRANDS_FAIL";
export const ADMIN_MERCHANT_SEARCH_BRANDS_RESET = "ADMIN_MERCHANT_SEARCH_BRANDS_RESET";

export const MERCHANT_ADD_BRAND_REQUEST = "MERCHANT_ADD_BRAND_REQUEST";
export const MERCHANT_ADD_BRAND_SUCCESS = "MERCHANT_ADD_BRAND_SUCCESS";
export const MERCHANT_ADD_BRAND_FAIL = "MERCHANT_ADD_BRAND_FAIL";

export const MERCHANT_REMOVE_BRAND_REQUEST = "MERCHANT_REMOVE_BRAND_REQUEST";
export const MERCHANT_REMOVE_BRAND_SUCCESS = "MERCHANT_REMOVE_BRAND_SUCCESS";
export const MERCHANT_REMOVE_BRAND_FAIL = "MERCHANT_REMOVE_BRAND_FAIL";

export const ADMIN_MERCHANT_VIEW_BRAND_REQUEST = "ADMIN_MERCHANT_VIEW_BRAND_REQUEST";
export const ADMIN_MERCHANT_VIEW_BRAND_SUCCESS = "ADMIN_MERCHANT_VIEW_BRAND_SUCCESS";
export const ADMIN_MERCHANT_VIEW_BRAND_FAIL = "ADMIN_MERCHANT_VIEW_BRAND_FAIL";

export const ADMIN_MERCHANT_LIST_BRAND_REQUEST = "ADMIN_MERCHANT_LIST_BRAND_REQUEST";
export const ADMIN_MERCHANT_LIST_BRAND_SUCCESS = "ADMIN_MERCHANT_LIST_BRAND_SUCCESS";
export const ADMIN_MERCHANT_LIST_BRAND_FAIL = "ADMIN_MERCHANT_LIST_BRAND_FAIL";

export const ADMIN_MERCHANT_UPDATE_BRAND_REQUEST = "ADMIN_MERCHANT_UPDATE_BRAND_REQUEST";
export const ADMIN_MERCHANT_UPDATE_BRAND_SUCCESS = "ADMIN_MERCHANT_UPDATE_BRAND_SUCCESS";
export const ADMIN_MERCHANT_UPDATE_BRAND_FAIL = "ADMIN_MERCHANT_UPDATE_BRAND_FAIL";

export const ADMIN_MERCHANT_REMOVE_BRAND_REQUEST = "ADMIN_MERCHANT_REMOVE_BRAND_REQUEST";
export const ADMIN_MERCHANT_REMOVE_BRAND_SUCCESS = "ADMIN_MERCHANT_REMOVE_BRAND_SUCCESS";
export const ADMIN_MERCHANT_REMOVE_BRAND_FAIL = "ADMIN_MERCHANT_REMOVE_BRAND_FAIL";

export const MERCHANT_SELECT = "MERCHANT_SELECT";
export const MERCHANT_REMOVE = "MERCHANT_REMOVE";
